/** Default Monaco options for TabbedCodeEditor in MetadataEditorPanel */
export const METADATA_TABBED_EDITOR_OPTIONS = {
  formatOnPaste: true,
  formatOnType: true,
  autoIndent: "full" as const,
  tabSize: 4,
  insertSpaces: true,
  wordWrap: "on" as const,
  minimap: { enabled: false },
  scrollBeyondLastLine: false,
  fontSize: 13,
  lineNumbers: "on" as const,
  renderWhitespace: "selection" as const,
  bracketPairColorization: { enabled: true },
  guides: {
    bracketPairs: true,
    indentation: true,
  },
};
